import { Backend } from '../Backend';
import { IReminderElementV1, IReminderUpdateV1 } from '../models/AndromeTV.types';
import { ReminderFilter, ReminderID } from './ReminderApi.types';

export class ReminderApi {
  /**
   * Retrieve the reminder with the specified type and id
   */
  static reminder(backend: Backend, reminderId: ReminderID): Promise<IReminderElementV1> {
    const type = encodeURIComponent(reminderId.type);
    const id = encodeURIComponent(reminderId.id);
    const url = backend.makeUrl(`history/v1/reminder/${type}/${id}`, {
      profileId: reminderId.profileId,
    });
    return backend.getJson(url, backend.bearer) as Promise<IReminderElementV1>;
  }

  /**
   * Create or update a reminder
   */
  static update(backend: Backend, reminderId: ReminderID, value: IReminderUpdateV1) {
    const type = encodeURIComponent(reminderId.type);
    const id = encodeURIComponent(reminderId.id);
    const url = backend.makeUrl(`history/v1/reminder/${type}/${id}`, {
      profileId: reminderId.profileId,
    });
    return backend.putJson(url, value, backend.bearer);
  }

  /**
   * Remove a reminder
   */
  static delete(backend: Backend, reminderId: ReminderID) {
    const type = encodeURIComponent(reminderId.type);
    const id = encodeURIComponent(reminderId.id);
    const url = backend.makeUrl(`history/v1/reminder/${type}/${id}`, {
      profileId: reminderId.profileId,
    });
    return backend.delete(url, backend.bearer);
  }

  /**
   * Retrieve a list of reminders
   */
  static list(backend: Backend, filter: ReminderFilter): Promise<IReminderElementV1[]> {
    const url = backend.makeUrl('history/v1/reminder', filter);
    return backend.getJson(url, backend.bearer) as Promise<IReminderElementV1[]>;
  }
}
